import { c as _c } from "react/compiler-runtime";
import { IcoWarning24 } from '@onefootprint/icons';
import { Button, LoadingSpinner } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type InitViewProps = {
  isError: boolean;
  retryLimitExceeded: boolean;
  onRetry: () => void;
};
const InitView = t0 => {
  const $ = _c(15);
  const {
    isError,
    retryLimitExceeded,
    onRetry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.selfie.pages.init"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  if (isError) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <IcoWarning24 color="error" />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== retryLimitExceeded || $[3] !== t) {
      t3 = retryLimitExceeded ? t(_temp) : t(_temp2);
      $[2] = retryLimitExceeded;
      $[3] = t;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t3) {
      t4 = <div className="flex flex-col items-center justify-center gap-2">{t2}<div className="text-body-2 text-secondary text-center">{t3}</div></div>;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== onRetry || $[8] !== retryLimitExceeded || $[9] !== t) {
      t5 = !retryLimitExceeded && <Button onClick={onRetry}>{t(_temp3)}</Button>;
      $[7] = onRetry;
      $[8] = retryLimitExceeded;
      $[9] = t;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t4 || $[12] !== t5) {
      t6 = <div className="flex h-full flex-col justify-center items-center gap-4 py-4 px-6">{t4}{t5}</div>;
      $[11] = t4;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  let t2;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col items-center h-full min-h-[var(--loading-container-min-height)] justify-center text-center"><LoadingSpinner size="xlarge" /></div>;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};
export default InitView;
function _temp($) {
  return $["retry-limit-exceeded"];
}
function _temp2($_0) {
  return $_0.error;
}
function _temp3($_1) {
  return $_1["try-again"];
}